<template>
  <div>
    <van-field
      v-model="useMessage.username"
      name="username"
      label="姓名"
      required
      :rules="[rule_required]"
      placeholder="请输入姓名"
    />
    <van-field name="sex" label="性别" required>
      <template #input>
        <van-radio-group v-model="useMessage.sex" direction="horizontal">
          <van-radio name="1">男</van-radio>
          <van-radio name="0">女</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-field
      v-if="useMessage._id"
      :disabled="true"
      v-model="useMessage.tel"
      type="tel"
      name="tel"
      required
      label="电话"
      placeholder="请填写电话"
    />
    <van-field
      v-else
      v-model="useMessage.tel"
      type="tel"
      name="tel"
      required
      label="电话"
      placeholder="请填写电话"
      :rules="[rule_required, rule_tel]"
    />
    <van-field
      readonly
      clickable
      required
      name="pcc"
      :value="useMessage.pcc"
      label="地区选择"
      :rules="[rule_required]"
      placeholder="点击选择省市区"
      @click="showArea = true"
    />
    <van-field
      v-model="useMessage.detail"
      required
      type="text"
      name="detail"
      label="详细地址"
      placeholder="请填写详细地址"
      :rules="[{ required: true, message: '请填写详细地址' }]"
    />
    <van-field label="客户类型" required>
      <template #input>
        <van-radio-group v-model="useMessage.客户类型" direction="horizontal">
          <van-radio name="个人">个人</van-radio>
          <van-radio name="公司">公司</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-field
      v-model="useMessage.国籍"
      readonly
      required
      clickable
      label="国籍"
      placeholder="国籍"
      :rules="[rule_required]"
      @click="ShowPopub('国籍')"
    />
<van-field
      v-model="useMessage.证件类型"
      readonly
      required
      clickable
      label="证件类型"
      placeholder="证件类型"
      :rules="[rule_required]"
      @click="ShowPopub('证件类型')"
    />
    <van-field
      v-model="useMessage.证件号码"
      required
      type="text"
      name="detail"
      label="证件号码"
      placeholder="请填写证件号码"
      :rules="[{ required: true, message: '请填写证件号码' }]"
    />
    <van-field
      v-model="useMessage.证件地址"
      required
      type="text"
      label="证件地址"
      placeholder="请填写证件地址"
      :rules="[{ required: true, message: '请填写证件地址' }]"
    />
    <van-field
      v-model="useMessage.通讯地址"
      required
      type="text"
      name="detail"
      label="通讯地址"
      placeholder="请填写通讯地址"
      :rules="[{ required: true, message: '请填写通讯地址' }]"
    />
    <van-field
      v-model="useMessage.邮编"
      required
      type="text"
      name="detail"
      label="邮编"
      placeholder="请填写邮编"
      :rules="[{ required: true, message: '请填写邮编' }]"
    />
    <van-field
      v-model="useMessage.电子邮箱"
      type="text"
      name="detail"
      label="电子邮箱"
      placeholder="请填写电子邮箱"
    />

    
    

    
    
    

    <van-field
      v-model="useMessage.remark"
      type="text"
      name="remark"
      label="备注"
      placeholder="备注"
    />
    <!-- 地区选择弹窗 -->
    <van-popup v-model="showArea" position="bottom">
      <van-area
        :area-list="areaList"
        @confirm="onConfirm"
        @cancel="showArea = false"
      />
    </van-popup>

    <van-popup v-model="showPopup" position="bottom">
      <van-picker
        title="请选择"
        show-toolbar
        :columns="popupList"
        @cancel="showPopup = false"
        @confirm="onPopupConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import { area1 } from "@/utils/area";
export default {
  name: "userMessage",
  props: {
    useMessage: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      areaList: area1,
      showArea: false,
      showPopup: false,
      popubName: "",
      popubIndex: -1,
      questionnaire: [],
      popupList: [],
      rule_required: { trigger: "onBlur", required: true, message: "*" },
      //pattern: /^[1][3,4,5,7,8][0-9]{9}$/, //用户名正则校验
      rule_tel: {
        trigger: "onBlur",
        validator: (value) => {
          return /^(0|86|17951)?(13[0-9]|15[012356789]|16[0-9]|17[35678]|18[0-9]|19[0-9]|199|14[57])[0-9]{8}$/.test(
            value
          );
        },
        message: "不是有效的手机号",
      },
    };
  },
  created() {
    //this.getQuestionnaire();
  },

  methods: {
    lockTel() {
      return this.useMessage._id != "";
    },
    ShowPopub(name) {
      this.popubName = name;
      if (name == "证件类型") {
        this.popupList = ["身份证"];
      }
      if (name == "国籍") {
        this.popupList = ["中国"];
      }
      this.showPopup = true;
    },
    onPopupConfirm(value) {
      this.useMessage[this.popubName] = value;
      this.showPopup = false;
    },
    //选择城市
    onConfirm(values) {
      this.useMessage.pcc = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("-");
      console.log(this.value);
      this.showArea = false;
    },
  },
  components: {},
};
</script>